import IBasicResponse from "@/interfaces/Data/IBasicResponse";
import { ILoginParameter, ILoginResponse } from "@/interfaces/Data/Login";
import baseApi from "../baseApi";
import { getLocalStore, getSession } from "@/utils/Session";
import System from "@/static/public";

export const authApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        login: build.mutation<ILoginResponse, ILoginParameter>({
            query: (data) => {
                return {
                    url: "/auth/api/login",
                    method: "POST",
                    body: data,
                };
            },
            transformResponse: (response: IBasicResponse<ILoginResponse>) => {
                return response.data;
            },
        }),
        logout: build.mutation<void, void>({
            query: () => {
                const refreshToken = getSession(System.ADMIN_REFRESH_TOKEN) || getLocalStore(System.ADMIN_REFRESH_TOKEN);
                return {
                    url: "/auth/api/logout",
                    method: "POST",
                    body: { refresh_token: refreshToken },
                };
            },
        }),
        refreshToken: build.mutation<ILoginResponse, void>({
            query: () => {
                const refreshToken = getSession(System.ADMIN_REFRESH_TOKEN) || getLocalStore(System.ADMIN_REFRESH_TOKEN);
                return {
                    url: "/auth/api/refresh_token",
                    method: "POST",
                    body: { refresh_token: refreshToken },
                };
            },
            transformResponse: (response: IBasicResponse<ILoginResponse>) => {
                return response.data;
            },
        }),
    }),
});

export const { useLoginMutation, useLogoutMutation, useRefreshTokenMutation } =
    authApi;
